/**
 * Favorites reference three kinds of entities:
 * - 'listing'      — private host stays (numeric id)
 * - 'boondocking'  — public-land stays (numeric id)
 * - 'poi'          — utility POIs (numeric id, stringified as `IPoi.id`)
 *
 * Persistence lives in `FavoritesService` (real backend, requires sign-in) —
 * this file only keeps the shared shape/key-helper both the service and its
 * consumers rely on.
 */

export type FavoriteKind = 'listing' | 'boondocking' | 'poi';

export interface IFavorite {
  kind: FavoriteKind;
  /** number for stays + boondocking; string for POIs (numeric id, stringified). */
  id: number | string;
  /** ISO timestamp the entry was favorited, when known. Real favorite rows have
   *  no timestamp column server-side — see FavoritesService for the fallback. */
  savedAt: string;
}

/** Canonical Set key — "listing:81" / "poi:42". */
export function favoriteKey(kind: FavoriteKind, id: number | string): string {
  return `${kind}:${id}`;
}
